import React, { useEffect } from "react";

function Footer () {

  return (
    <div className={`visual-footer `}>
      <p>
        © {new Date().getFullYear()}
        <span
          className="clickable"
          onClick={ () => {window.open("https://mynext.id/", "_blank")}}
        >
          {" "}
          MyNextID{" "}
        </span>
        | 
         <span 
          className="clickable"
          onClick={() => {
            //navigate("/privacyPolicy");
          }}
        >
          {" "}
         <a href="https://github.com/MyNextID/mDL-verifier" target={"_blank"}>mDL Verifier GitHub </a>
        (v. 1.0.4)
        </span>
        <br></br>
        <br></br>
        <span 
          className="clickable"
          onClick={() => {
            //navigate("/privacyPolicy");
          }}
        >
          {" "}
          If you have any issues, questions, or suggestions, <br></br>
          please open a <a href="https://github.com/MyNextID/mDL-verifier/issues" target={"_blank"}>GitHub issue</a>.
        </span>
      </p>
    </div>
  );
};

export default Footer;